import styled, { keyframes } from 'styled-components';
function Maps() {
  return (
    <Wrap>
      <p>오시는 길</p>
      <div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12649.327301949013!2d126.9798544!3d37.5708033!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe9780eb21c131dff!2z67KV66Wg7IKs66y07IaMIO2biA!5e0!3m2!1sko!2skr!4v1647775224328!5m2!1sko!2skr"
          loading="lazy"
        ></iframe>
      </div>
    </Wrap>
  );
}

const Wrap = styled.div`
  /* background-color: ${props => props.theme.bgColor}; */
  width: 100%;
  padding: 50px 0 0;
  p {
    color: ${props => props.theme.mainColor};
    font-weight: bold;
    position: relative;
    width: 100px;
    margin: 20px auto 30px;
    font-size: 20px;
    &::before {
      position: absolute;
      content: '';
      display: block;
      top: -15px;
      left: -50px;
      width: 40px;
      height: 40px;
      background: url(/images/maps_marker.svg) no-repeat center;
      background-size: auto 100%;
    }
  }
  div {
    margin: 0 auto;
    width: 100%;
    height: 400px;
    iframe {
      width: 100%;
      height: 100%;
    }
  }
`;

export default Maps;
